import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconEsportsPersonSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 34 34`}
    >
      <g
        id="グループ_26"
        data-name="グループ 26"
        transform="translate(2.894 3.844)"
      >
        <rect
          id="Frame"
          width="34"
          height="34"
          transform="translate(-2.894 -3.844)"
          fill="rgba(0,0,0,0)"
          opacity="0"
        />
        <g
          id="グループ_25"
          data-name="グループ 25"
          transform="translate(1.106 0.94)"
          clipPath="url(#clip-path)"
        >
          <path
            id="パス_32"
            data-name="パス 32"
            d="M22.947,10.761A9.772,9.772,0,0,0,21.207,5.8a2.278,2.278,0,0,0-.417-2.813A11.628,11.628,0,0,0,13,0,11.374,11.374,0,0,0,5.311,2.991,2.279,2.279,0,0,0,4.894,5.8a9.774,9.774,0,0,0-1.74,4.957A3.862,3.862,0,0,0,0,14.507v1.527a3.861,3.861,0,0,0,3.859,3.818H5.383a.762.762,0,0,0,.762-.763V11.453a.762.762,0,0,0-.762-.763h-.7A8.257,8.257,0,0,1,6.056,6.8a2.361,2.361,0,0,0,2.408-.466,7.047,7.047,0,0,1,9.172,0,2.362,2.362,0,0,0,2.408.467,8.258,8.258,0,0,1,1.373,3.887h-.7a.762.762,0,0,0-.762.763v7.635a.762.762,0,0,0,.762.763h.762v.764a.763.763,0,0,1-.762.763H15.145a2.291,2.291,0,1,0,0,1.527h5.574A2.29,2.29,0,0,0,23,20.615v-.841a3.778,3.778,0,0,0,3-3.74V14.507a3.773,3.773,0,0,0-3.053-3.746"
          />
        </g>
      </g>
    </svg>
  );
};
